import { METHOD, request } from "./../../utils/request";
import { Debts } from "./../api";

async function getAll(params) {
  return request(Debts.getAll, METHOD.GET, params);
}
async function getDetails(params) {
  return request(Debts.getDetails, METHOD.GET, params);
}
async function getDialog(params) {
  return request(Debts.getDialog, METHOD.GET, params);
}

async function deleteDebtInstallments(data) {
  return request(Debts.deleteDebtInstallments, METHOD.POST, data);
}

export default {
  getAll,
  getDetails,
  getDialog,
  deleteDebtInstallments,
};
